var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import qs from "qs";
// post 请求参数parse
export var postDataParse = function (data) {
    var theData = qs.parse(data);
    if (theData.body &&
        Object.prototype.toString.call(theData.body) === "[object String]") {
        theData.body = JSON.parse(theData.body);
    }
    return theData;
};
// post 请求参数初始化
export var postDataInit = function (data) {
    return qs.stringify(__assign(__assign({}, data), { body: JSON.stringify(data.body) }));
};
